import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import DocumentTitle from 'react-document-title'
import {Tabs} from 'antd'
const TabPane = Tabs.TabPane
import Controls from './Controls'
import AlgoTable from './AlgoTable'
import BacktestTable from './BacktestTable'
import LiveTradeModal from './Modals/LiveTrade'

import style from './style.sass'

@inject('store') @observer
class Manager extends Component {
  state = {
    height: 0,
    liveTrade: {
      modal: false,
      algo: null
    }
  }
  componentDidMount() {
    this.calculateHeight()
    window.addEventListener('resize', this.calculateHeight)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateHeight)
  }
  calculateHeight = () => {
    const box = document.querySelector('.ant-table-body').getBoundingClientRect()
    const windowHeight = window.innerHeight
    this.setState({
      height: Math.max((windowHeight - box.top - 215), 200)
    })
  }
  changeTab = (key) => {
    key = key.replace(/[^\w\s]/gi, '')
    this.props.history.push({
      search: `tab=${key}`
    })
  }
  openLiveTradeModal = (algo) => {
    this.setState({
      liveTrade: {modal: true, algo}
    })
  }
  closeLiveTradeModal = () => {
    this.setState({
      liveTrade: {modal: false, algo: null}
    })
  }
  render() {
    const search = this.props.history.location.search
    const tab = search ? search.match(/tab=([^&]*)/)[1] : 'algo'
    const {liveTrade} = this.state
    return(
      <div styleName='wrapper'>
        <DocumentTitle title='Algo Manager'/>
        <LiveTradeModal visible={liveTrade.modal} algo={liveTrade.algo} close={this.closeLiveTradeModal}/>
        <Controls tab={tab}/>
        <Tabs
          type='card'
          activeKey={tab}
          onChange={this.changeTab}
          styleName='tabs'
        >
          <TabPane tab='Algos' key='algo'>
            <AlgoTable height={this.state.height} openLiveTradeModal={this.openLiveTradeModal}/>
          </TabPane>
          <TabPane tab='Backtest' key='backtest'>
            <BacktestTable height={this.state.height} openLiveTradeModal={this.openLiveTradeModal}/>
          </TabPane>
        </Tabs>
      </div>
    )
  }
}

export default Manager
